import { createAsyncThunk } from '@reduxjs/toolkit'
import { getCollector } from '../../apiHelper/collectorApi'
import { COLLECTOR_URL } from '../../apiHelper/apiRoute/collector'

const HOLD_GET_SIZE = 250

export const getProviderHoldList = createAsyncThunk(
  'providerhold/list',
  async ({ thisProvider, activeButton = 'provider', holdPage = 0, refresh = false }, thunkAPI) => {
    try {
      if (
        holdPage <= thunkAPI.getState()?.providerHold?.holdPage &&
        thunkAPI.getState()?.providerHold?.holdPatients?.length > 0 &&
        !refresh
      ) {
        return thunkAPI.getState()?.providerHold
      }

      const url = COLLECTOR_URL.GET_PROVIDER_HOLD_DATA.replace(
        '{startIndex}',
        `${holdPage * HOLD_GET_SIZE}`,
      )
        .replace('{recordCount}', `${HOLD_GET_SIZE}`)
        .replace('{scope}', `${activeButton.toLowerCase()}`)
      const resLists = await getCollector(url)
      if (resLists?.status === 500) {
        return 'Server Error'
      } else {
        if (resLists?.status === 'SUCCESS') {
          let arr = resLists?.data?.result
          for (let i = 0; i < arr?.length; i++) {
            if (arr[i]?.hold_date?.statuses?.length === 0) {
              arr[i].provider_hold_date = arr[i]?.hold_date?.last_modified_date
            } else {
              const datetimes = arr[i]?.hold_date?.statuses?.map((item) => {
                return item?.status_date
              })

              let maxDatetimeObj = datetimes[0] // start with the first object as the max datetime

              for (let i = 1; i < datetimes.length; i++) {
                const currentTimestamp = Date.parse(datetimes[i])
                const maxTimestamp = Date.parse(maxDatetimeObj)
                if (currentTimestamp > maxTimestamp) {
                  maxDatetimeObj = datetimes[i]
                }
              }

              arr[i].provider_hold_date = maxDatetimeObj
            }
          }

          return {
            inPatients: arr || [],
            holdPage: holdPage,
            totalCount: resLists?.data?.total,
            lastHoldType: activeButton,
            refresh,
          }
        }
      }
    } catch (err) {
      console.error('getting error in rendering census', err)
      return false
    }
  },
)
